import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Avatar, Drawer, Button } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar from "./sidebar/Sidebar";
import Notifications from "./Notifications";
import { roles } from "shared/constants/Constants";
import allRoles from "rbac/AllRoles";
import ProfileAccountDropdown from "./ProfileAccountDropdown";
import {
  SHOW_PORTAL_SELECTION_MODAL,
  userCanAccessDeskPortal,
} from "feature/authv2/portalDeskConfig";

export default function Header({
  handleLogout,
  avatarIcon,
  role,
  userName,
  avatarClass,
  sidebarListClick,
  setSidebarListClick,
  email,
}) {
  const navigate = useNavigate();
  const reduxState = useSelector((state) => state);
  const [userRole, setUserRole] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const userRoles = useMemo(() => reduxState.role?.roles ?? [], [reduxState.role]);
  const showDeskPortalMenu = useMemo(
    () => SHOW_PORTAL_SELECTION_MODAL && userCanAccessDeskPortal(userRoles),
    [userRoles]
  );

  const navigateToDeskPortal = useCallback(() => {
    if (showDeskPortalMenu) {
      navigate("/desk");
    }
  }, [navigate, showDeskPortalMenu]);

  useEffect(() => {
    if (reduxState?.role && reduxState?.role?.roles?.length > 0) {
      setUserRole(reduxState.role?.roles[0]);
    }
  }, [reduxState.role]);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  return (
    <div className="header-container">
      <div className="flex justify-between items-center p-[10px] md:p-4 md:m-0 w-full gap-2">
        <div className="flex items-center -ml-[10px] shrink-0">
          {userRole === "hub_manager" ||
          userRole === "admin" ||
          userRole === "parking" ||
          userRole === "onboarding" ||
          userRole === "finance" ||
          userRole === roles.TELECALLING ||
          RbacSidebar["sidebar"][userRole] ? (
            <div className="flex items-center">
              <Button type="text" onClick={showDrawer} className="p-0">
                <img src="/icons/basil_menu-outline.svg" alt="Menu" className="h-[55px]" />
              </Button>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="flex-1 flex justify-center min-w-0">
          <img src="/icons/carrum.svg" alt="Company Logo" className="h-8 mx-auto" />
        </div>

        <div className="flex items-center shrink-0 gap-1">
          <Notifications />
          <ProfileAccountDropdown
            handleLogout={handleLogout}
            email={email}
            userName={userName}
            showDeskPortalMenu={showDeskPortalMenu}
            onNavigateToDeskPortal={navigateToDeskPortal}
            placement="bottomRight"
          >
            <div className="flex items-center cursor-pointer p-1" role="button" tabIndex={0}>
              <Avatar src={avatarIcon} size="large" className={avatarClass} />
              <DownOutlined className="ml-1 text-[#6e6e6e]" style={{ fontSize: 12 }} />
            </div>
          </ProfileAccountDropdown>
        </div>
      </div>
      {role ? (
        <Drawer
          title="Menu"
          placement="left"
          onClose={closeDrawer}
          visible={drawerVisible}
          style={{ width: "100%" }}
          width={230}
          className=""
        >
          <div className=" sidebar-dashboard-container-md">
            {(userRole === "hub_manager" ||
              userRole === "admin" ||
              userRole === "finance" ||
              userRole === "onboarding" ||
              userRole === roles.TELECALLING ||
              RbacSidebar["sidebar"][userRole]) && (
              <Sidebar
                sidebarListClick={sidebarListClick}
                setSidebarListClick={setSidebarListClick}
              />
            )}
          </div>
        </Drawer>
      ) : (
        ""
      )}
    </div>
  );
}

const RbacSidebar = {
  sidebar: {
    ...allRoles,
    admin: true,
    vendor: true,
    verification: true,
    hub_manager: true,
    onboarding: true,
    driver_manager: true,
    finance: true,
    procurement: true,
    parking: true,
    recovery_agent: true,
    senior_driver_manager: true,
    fleet_manager: true,
    fleet_general_manager: true,
  },
};
